import _toConsumableArray from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getBoxOutline as _getBoxOutline } from '@/api/modules/study.js';
import OutlineCache from '@/utils/OutlineCache.js';
import BoxMainOutlineZhang from '@/views/study/components/box-main-outline-zhang.vue';
import BoxMainOutlineCard from '@/views/study/components/box-main-outline-card.vue';
import BoxMainOutlineCollapse from '@/views/study/components/box-main-outline-collapse.vue';
import BoxGuideOutline from '@/views/study/components/guide/box-guide-outline.vue';
import { filterOutlineNodes } from '@/views/study/constance.js';
var cache = OutlineCache.getInstance();
export default {
  name: 'BoxMainOutline',
  components: {
    BoxMainOutlineZhang: BoxMainOutlineZhang,
    BoxMainOutlineCard: BoxMainOutlineCard,
    BoxMainOutlineCollapse: BoxMainOutlineCollapse,
    BoxGuideOutline: BoxGuideOutline
  },
  props: {
    boxId: {
      type: [String, Number],
      default: ''
    },
    subjectCode: {
      type: Number,
      default: 0
    },
    states: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    return {
      box: null,
      edu: JSON.parse(localStorage.getItem('userInfo')).edu,
      selectNode: null,
      // 选中的叶子节点
      expandNodes: [],
      showEmpty: false,
      emptyImg: this.$resource('ucan_img_study_empty2.png')
    };
  },
  computed: _objectSpread({}, mapGetters(['closeCodeDialog', 'progressSelectNode'])),
  watch: {
    states: {
      handler: function handler() {
        this.filterNode();
      },
      deep: true
    },
    boxId: function boxId() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getBoxOutline();

              case 2:
                _this.filterNode();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    closeCodeDialog: function closeCodeDialog(val) {
      val && this.getBoxOutline(); // 关闭弹窗刷新数据
    },
    progressSelectNode: function progressSelectNode(val) {
      console.log(val, 'val');
      this.getBoxOutline();
    }
  },
  created: function created() {
    this.getBoxOutline();
  },
  methods: {
    getBoxOutline: function getBoxOutline() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_getBoxOutline, status, data, isUpdateCache;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.boxId) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return _getBoxOutline({
                  boxId: _this2.boxId
                });

              case 4:
                _yield$_getBoxOutline = _context2.sent;
                status = _yield$_getBoxOutline.status;
                data = _yield$_getBoxOutline.data;

                if (!(status !== 1)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return");

              case 9:
                _this2.selectNode = cache.getSelectNode(_this2.edu, _this2.subjectCode, _this2.boxId);
                _this2.box = data.content || []; // 匹配正确的大纲节点

                isUpdateCache = _this2.findRealNode();

                _this2.$emit('changeOutline', _this2.selectNode, isUpdateCache);

                _this2.expandNodes = cache.getOpenNodes(_this2.edu, _this2.subjectCode, _this2.boxId) || [];

                _this2.scrollChapter();

                _this2.filterNode();

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    scrollChapter: function scrollChapter() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _ref, chapterId, chapter;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$nextTick();

              case 2:
                _ref = _this3.selectNode || {}, chapterId = _ref.chapterId;

                if (chapterId) {
                  chapter = _this3.$refs["outline_chapter_".concat(chapterId)];
                  chapter && chapter[0] && chapter[0].scrollIntoView(true);
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    nodeClick: function nodeClick(node, chapter) {
      // 挂上章ID，在初始化时要根据章ID滚动到对应的章
      if (node) {
        this.selectNode = _objectSpread(_objectSpread({}, node), {}, {
          chapterId: chapter.outLineId
        });
      } else {
        // 点击的使用引导
        this.selectNode = node;
      }

      this.$emit('changeOutline', this.selectNode, true);
    },
    filterNode: function filterNode() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.box) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                filterOutlineNodes(_this4.states, _this4.box, _this4);
                _context4.next = 5;
                return _this4.$nextTick();

              case 5:
                // 章全部隐藏调出空样式
                _this4.showEmpty = !_this4.box.length || _this4.box.every(function (b) {
                  return b.hideNode;
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    expandCollNode: function expandCollNode(outlineId) {
      var idx = this.expandNodes.findIndex(function (i) {
        return i === outlineId;
      });

      if (idx !== -1) {
        // 收起
        this.expandNodes.splice(idx, 1);
      } else {
        // 展开
        this.expandNodes.push(outlineId);
        this.expandNodes = _toConsumableArray(new Set(this.expandNodes));
      }

      cache.changeOpenNodes(this.edu, this.subjectCode, this.boxId, this.expandNodes);
    },
    chapterClick: function chapterClick(chapter) {
      this.nodeClick(chapter, chapter);
    },
    findRealNode: function findRealNode() {
      if (this.selectNode && this.selectNode.arouseNode) {
        // 唤起节点，匹配正确的大纲节点
        // virtualType 0: 关卡 5: 关 6: 章
        var _this$selectNode = this.selectNode,
            outLineId = _this$selectNode.outLineId,
            virtualType = _this$selectNode.virtualType; // 1: 本关服务 2: 本章服务 3: 本关练习 4: 本章练习

        var currentNode;

        if (virtualType === 6) {
          currentNode = this.box.find(function (item) {
            return item.outLineId === +outLineId;
          });
        } else if (virtualType === 5) {
          var shuts = this.box.reduce(function (res, next) {
            var _next$children;

            if ((_next$children = next.children) !== null && _next$children !== void 0 && _next$children.length) {
              return res.concat(next.children);
            }

            return res;
          }, []);
          currentNode = shuts.find(function (item) {
            return item.outLineId === +outLineId;
          });
        } else if (virtualType === 0) {
          var levels = [];

          for (var i = 0; i < this.box.length; i++) {
            var _box$children;

            var box = this.box[i];

            if ((_box$children = box.children) !== null && _box$children !== void 0 && _box$children.length) {
              levels = levels.concat(box.children.reduce(function (res, next) {
                var _next$children2;

                if ((_next$children2 = next.children) !== null && _next$children2 !== void 0 && _next$children2.length) {
                  return res.concat(next.children);
                }

                return res;
              }, []));
            }
          }

          currentNode = levels.find(function (item) {
            return item.outLineId === +outLineId;
          });
        } else if (virtualType === 4) {
          var chapterExercises = this.box.reduce(function (res, next) {
            var _next$virtualNode;

            if ((_next$virtualNode = next.virtualNode) !== null && _next$virtualNode !== void 0 && _next$virtualNode.length) {
              return res.concat(next.virtualNode);
            }

            return res;
          }, []);
          currentNode = chapterExercises.find(function (item) {
            return item.virtualId === +outLineId && item.type === 4;
          });
        } else if (virtualType === 3) {
          var levelExercises = [];

          for (var _i = 0; _i < this.box.length; _i++) {
            var _box$children2;

            var _box = this.box[_i];

            if ((_box$children2 = _box.children) !== null && _box$children2 !== void 0 && _box$children2.length) {
              levelExercises = levelExercises.concat(_box.children.reduce(function (res, next) {
                var _next$virtualNode2;

                if ((_next$virtualNode2 = next.virtualNode) !== null && _next$virtualNode2 !== void 0 && _next$virtualNode2.length) {
                  return res.concat(next.virtualNode);
                }

                return res;
              }, []));
            }
          }

          currentNode = levelExercises.find(function (item) {
            return item.virtualId === +outLineId && item.type === 3;
          });
        }

        if (currentNode) {
          this.selectNode = currentNode;
          return true;
        }
      }

      return false;
    }
  }
};